import React from 'react'
import {Popup} from 'devextreme-react/popup'
import 'devextreme-react/text-area'
import 'devextreme-react/file-uploader'
import ScrollView from 'devextreme-react/scroll-view'
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import {Button} from "devextreme-react/button";
// По дефолту показывается только кнопка ок.
// Например вывод мессаги и по ок закрытие
// onOk={()=>{setPopupErrorVisible(false)}}
// Если необходимо действие после нажатия ок можно отобразить еще кнопку отмены действия
// btnVisibleCancel = true
// тогда в onCancel передаем закрытие popup
// onCancel={()=>{setPopupErrorVisible(false)}}
// а в onOk функцию обработчик необходимого действия

const ErrorPopup = (props) => {

    let showTitle = props.showTitle || true
    let visible = props.visible
    let text = props.text
    let width = props.width
    let icon = props.icon
    let btnVisible = props.btnVisible
    let btnVisibleCancel = props.btnVisibleCancel ?? false
    let onCancel = props.onCancel ?? props.onOk
    let onCancelWithOk = props.onCancelWithOk ?? props.onCancel
    let onOk = props.onOk
    let title = props.title
    let classNameColorIcon = props.classNameColorIcon ?? 'error-color'
    let visibleCloseBtn = props.visibleCloseBtn ?? true
    let textOk = props.textOk ?? 'Ок'
    let textCancel = props.textCancel ?? 'Отмена'

    return (
        <Popup
            visible={visible}
            dragEnabled={true}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={showTitle}
            onHiding={onCancelWithOk}
            title="Контакты"
            maxWidth={width}
            maxHeight={'90%'}
            height={'auto'}
            titleRender={()=>PopupTitleWithIcon(icon, title,onCancel, visibleCloseBtn, classNameColorIcon)}
        >
            <ScrollView width='100%' height='100%'>{/*style={{textAlign: 'justify'}}*/}
                <div id={'myDiv'} dangerouslySetInnerHTML={{__html: text}}
                     tabIndex={0}
                     onKeyDown={(e) => {
                         if (e.key === 'Escape') onCancel()
                     }}></div>
                <div className={'mt-2'}>
                    <Button className={'float-right ml-2'} visible={btnVisible} text={textOk} onClick={onOk}/>
                    <Button className={'float-right'} visible={btnVisibleCancel} text={textCancel} onClick={onCancel}/>
                </div>
            </ScrollView>
        </Popup>
    )
}

export default ErrorPopup
